import { useTranslation } from "react-i18next";
import { Link, LinkType } from "~/common/components/Link";
import Parameter from "~/common/components/Parameter";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export const MyAccountParts = {
  ChangeEmailLink: ({ href }: { href?: string }) => {
    const { t } = useTranslation();
    if (!href) {
      return null;
    }

    return (
      <Link variant={LinkType.PRIMARY} href={href} target={"_blank"} iconBefore={<OpenInNewIcon  />}>
        {t("myAccount.changeEmail")}
      </Link>
    );
  },
  EmailParameter: ({ email }: { email: string }) => {
    const { t } = useTranslation();
    return (
      <Parameter label={t("page.completeRegistration.email")} value={<div className="title-medium">{email}</div>} />
    );
  },
};
